// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import { router } from './router';
import { FirebaseModule } from '@/module/firebase';
// store
import { store } from '@/store';
// bootstrap
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'reset-css';
// font-awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faUser, faSignOutAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// component
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);

library.add(faPlus, faUser, faSignOutAlt, faSpinner);

Vue.config.productionTip = false;

const firebaseModule = new FirebaseModule();
firebaseModule.init();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
